import { RHAP_UI } from 'react-h5-audio-player'
import { FC, useCallback, useMemo, useState } from 'react'
import cx from 'classnames'

import { TranscriptProps } from '../Transcript'
import { PictureProps } from '../Picture'
import { Icons } from '../Icon'
import { colors } from '../../theme'

import * as SC from './styled'

export type PodcastProps = {
  className?: string
  // either url and other props or an embed code, not typing this shit
  media?: {
    title?: string
    subtitle?: string
    url?: string
    cover?: PictureProps
  }
  embed?: string
  transcriptProps?: TranscriptProps
  // inherits from the page
  color?: string
}

const Podcast: FC<PodcastProps> = ({
  className,
  media,
  embed,
  transcriptProps,
  color = colors.blueLight,
}) => {
  const [openTranscript, setOpenTranscript] = useState(false)
  const toggleTranscript = useCallback(
    () => setOpenTranscript(!openTranscript),
    [openTranscript]
  )
  //memoized or it rerenders and flickers when the transcript opens
  const memoizedEmbed = useMemo(() => {
    return <SC.Embed dangerouslySetInnerHTML={{ __html: embed ?? '' }} />
  }, [embed])

  return media?.url || embed ? (
    <SC.Container className={cx('Podcast', className)} $color={color}>
      {media?.url && (
        <SC.Wrapper>
          <SC.Content>
            {media.cover && <SC._Picture {...media.cover} />}
            {(media.title || media.subtitle) && (
              <SC.Infos>
                {media.title && <SC.Title>{media.title}</SC.Title>}
                {media.subtitle && <SC.Subtitle>{media.subtitle}</SC.Subtitle>}
              </SC.Infos>
            )}
          </SC.Content>
          <SC._AudioPlayer
            volume={0.5}
            src={media.url}
            showJumpControls={false}
            showSkipControls={false}
            showFilledVolume={true}
            customProgressBarSection={[
              RHAP_UI.MAIN_CONTROLS,
              <SC.Spacer
                key="Podcast-custom-0"
                $variant={SC.SpacerVariant.medium}
              />,
              RHAP_UI.CURRENT_TIME,
              <SC.TimeSeparator key="Podcast-custom-1">/</SC.TimeSeparator>,
              RHAP_UI.DURATION,
              <SC.Spacer key="Podcast-custom-2" />,
              RHAP_UI.PROGRESS_BAR,
              <SC.Spacer key="Podcast-custom-3" />,
              RHAP_UI.VOLUME,
              <SC.Spacer
                key="Podcast-custom-4"
                $variant={SC.SpacerVariant.medium}
              />,
              <SC.Button
                key="Podcast-custom-6"
                type="button"
                onClick={toggleTranscript}
              >
                <SC._Icon icon={Icons.playerTranscript} />
              </SC.Button>,
            ]}
            customControlsSection={[]}
            customAdditionalControls={[]}
            customVolumeControls={[]}
            customIcons={{
              play: <SC._Icon icon={Icons.playerPlay} />,
              pause: <SC._Icon icon={Icons.playerPause} />,
              volume: <SC._Icon icon={Icons.playerVolume2} />,
              volumeMute: <SC._Icon icon={Icons.playerVolumeMute} />,
            }}
            onError={() => {
              // console.log('play error')
            }}
            progressJumpSteps={{ backward: 10000, forward: 10000 }}
          />
        </SC.Wrapper>
      )}
      {embed && memoizedEmbed}
      {transcriptProps?.richTextProps?.jsonContent && (
        <SC._Transcript
          {...transcriptProps}
          open={openTranscript}
          toggleHandler={toggleTranscript}
        />
      )}
    </SC.Container>
  ) : null
}

export default Podcast
